import React, { useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import ImageIcon from '../../Icon/ImageIcon.component';
import I18n from '../../i18n/I18n.component';
import { convertFromUtc } from '../Clock.utils';
import { i18nService } from '../../../../services/i18n.service';
import useDevicePlatform, {
	DeviceType,
} from '../../../../hooks/useDevicePlatform.hook';
import { useSelector } from 'react-redux';
import { getUserData } from '../../../../store/selectors/login.selectors';
import colors from '../../../../config/colors';
export interface Record {
	workLogId: number;
	projectId: any;
	projectName: any;
	eventId: any;
	eventName: any;
	enterTime: any;
	exitTime: any;
	fullDay: boolean;
	total: number;
}
interface Props {
	record: Record;
	onDelete: Function;
	onEdit: Function;
	isToday?: any;
}

const RecordCard = ({ record, isToday, onEdit, onDelete }: Props) => {
	const convertMinutesToHours = (value: any, format?: string) => {
		if (value) {
			if (format === 'HH:mm') {
				const hours = `${Math.floor(value / 60)?.toLocaleString()}`;
				const minutes =
					value % 60 !== 0
						? value % 60 < 10
							? `0${value % 60}`
							: `${value % 60}`
						: '00';
				return `${hours}:${minutes}`;
			}
			return `${(value / 60).toFixed(2)}`;
		}
		return '';
	};
	const platform = useDevicePlatform();
	const isMobile = platform !== DeviceType.WEB;
	const userData = useSelector(getUserData);
	const canEdit = useMemo(
		() =>
			userData?.employeeRolePrivileges?.includes('ROLE_LOG_WORK_WRITE') &&
			userData.customer_setting.allowUpdateReport,
		[userData],
	);
	const hasExit = !!record.exitTime;

	return (
		<View style={styles.recordRow}>
			<View style={styles.header}>
				<I18n size={14} font='medium' color='titlePrimary'>
					{record.eventName || 'report'}
				</I18n>
				{canEdit && (
					<TouchableOpacity
						style={styles.editCell}
						onPress={() => onEdit?.(record.workLogId, record)}
					>
						<ImageIcon name='pencilEdit' />
					</TouchableOpacity>
				)}

			</View>
			<View style={styles.body}>
				<I18n
					size={14}
					font={record.total ? 'medium' : 'normal'}
					color={hasExit ? 'clockRecordBlue' : 'greyText'}
					style={{ opacity: record.total ? 1 : 0.3, marginLeft: 8 }}
				>
					{record.total
						? convertMinutesToHours(record.total, 'HH:mm')
						: '00:00'}
				</I18n>
				<ImageIcon
					name='chevronLeft'
					width={16}
					height={16}
					style={{ marginLeft: 8 }}
					color='darkGrey'
				/>
				<I18n
					size={14}
					weight='normal'
					color={hasExit ? 'clockRecordBlue' : 'greyText'}
					style={{ opacity: hasExit ? 1 : 0.3 , marginLeft: 8 }}
				>
					{record.exitTime
						? convertFromUtc(record.exitTime, true)
						: '00:00'}
				</I18n>
				<I18n
					size={14}
					weight='normal'
					color={'greyText'}
					style={{ marginLeft: 8 }}
				>
					-
				</I18n>
				<I18n
					size={14}
					weight='normal'
					color={
						!isToday && record.enterTime === '00:00'
							? 'red'
							: 'clockRecordBlue'
					}
					style={{marginLeft: 8 }}
				>
					{record.enterTime
						? convertFromUtc(record.enterTime, true)
						: '00:00'}
				</I18n>
			</View>
		</View>
	);
};
const styles = StyleSheet.create({
	recordRow: {
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		padding: 12,
		borderWidth: 1,
		borderRadius: 8,
		borderColor: colors.iconBG,
		marginBottom: 12,
	},
	header: {
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: 'row-reverse',
		width: '100%',
		marginBottom: 8,
	},
	body: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	cell: {
		flex: 1,
		alignItems: 'center',
	},
	editCell: {
		width: 40,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
export default RecordCard;
